import React from "react";
import { Helmet } from "react-helmet";

const MoaAoa = () => {
  return (
    <div>
      <Helmet>
        <title>MoaAoa | Nandan Denim Ltd .</title>
      </Helmet>

    </div>
  )
};

export default MoaAoa;
